module.exports = __webpack_public_path__ + "static/media/智能客服白皮书.3451988b.jpg";